(function () {
  if (window.scScrollToLoaded) return;
  window.scScrollToLoaded = true;

  var SETTLE_MS = 4000;
  var READY_MS = 5000;
  var TOLERANCE = 2;

  function desiredTop() {
    var pad = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop);
    return isNaN(pad) ? 0 : pad;
  }

  function find(hash) {
    if (!hash || hash.length < 2) return null;
    try {
      return document.querySelector(hash);
    } catch (e) {
      return null;
    }
  }

  // Vitals never renders if its block scrolls into view before it initializes.
  function whenReady(target, cb) {
    var deadline = Date.now() + READY_MS;
    var expectsVitals = target.querySelector('.Vtl-AppBlock');

    (function check() {
      var ready = !expectsVitals || (window.VITALS && window.VITALS.initialized);
      if (ready || Date.now() > deadline) return cb();
      setTimeout(check, 100);
    })();
  }

  function align(target, behavior) {
    target.scrollIntoView({ behavior: behavior, block: 'start' });
  }

  // The reviews app renders after the scroll starts, so the first scroll can
  // land short. Re-align each time the page settles until the target is in place.
  function settle(target, behavior) {
    var deadline = Date.now() + SETTLE_MS;
    var lastY = null;

    var timer = setInterval(function () {
      var y = Math.round(window.scrollY);
      var settled = y === lastY;
      lastY = y;

      if (settled) {
        var offset = target.getBoundingClientRect().top - desiredTop();
        var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        var short = offset > TOLERANCE && y < maxScroll - TOLERANCE;
        var over = offset < -TOLERANCE;
        if (short || over) align(target, behavior);
      }

      if (Date.now() > deadline) stop();
    }, 200);

    function stop() {
      clearInterval(timer);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
      window.removeEventListener('keydown', stop);
    }

    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });
    window.addEventListener('keydown', stop);
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-scroll-to]');
    if (!trigger) return;

    var target = find(trigger.getAttribute('data-scroll-to'));
    if (!target) return;

    whenReady(target, function () {
      align(target, 'smooth');
      settle(target, 'smooth');
    });
  });

  // Landing on the URL with the hash already set gets the browser's fragment
  // jump, which fires before the page below it has settled. Redo it on load,
  // unless the reader has already taken over.
  var initial = find(location.hash);
  if (!initial) return;

  var taken = false;
  function takeOver() {
    taken = true;
  }

  window.addEventListener('wheel', takeOver, { passive: true });
  window.addEventListener('touchstart', takeOver, { passive: true });
  window.addEventListener('keydown', takeOver);

    window.addEventListener('load', function () {
    whenReady(initial, function () {
      window.removeEventListener('wheel', takeOver);
      window.removeEventListener('touchstart', takeOver);
      window.removeEventListener('keydown', takeOver);
      if (taken) return;
      align(initial, 'auto');
      settle(initial, 'auto');
    });
  });
})();